import { Component, Input } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { BasePageComponent } from 'src/app/components/base-page/base-page.component';
import { takeUntil } from 'rxjs/operators';
import { UserInfoService } from 'src/app/services/auth/check-session/user-info.service';

@Component({
  selector: 'app-bank-account-details',
  templateUrl: './bank-account-details.component.html',
  styleUrls: ['./bank-account-details.component.scss']
})
export class BankAccountDetailsComponent extends BasePageComponent {

  constructor(
    private infoService: UserInfoService
  ) { super() }

  countries: { display: string, value: string }[] = [];
  savedAccounts: any;
  isAddNewAccount: boolean = false;

  setIsAddNewAccount(value: boolean) {
    this.createForm(value);
    this.isAddNewAccount = value;
  }

  @Input() parentForm: UntypedFormGroup;
  @Input() methodInfo: any;

  createForm(value: boolean) {
    if (value) {
      this.parentForm.addControl("bank_name", new UntypedFormControl('', [Validators.required]));
      this.parentForm.addControl("payee", new UntypedFormControl('', [Validators.required]));
      this.parentForm.addControl("swift_code", new UntypedFormControl('', [Validators.required]));
      this.parentForm.addControl("iban_account_number", new UntypedFormControl('', [Validators.required]));
      this.parentForm.addControl("iban_account_number_confirm", new UntypedFormControl('', [Validators.required]));
      this.parentForm.addControl("country", new UntypedFormControl('', [Validators.required]));

      this.infoService.requestCheckUserInfo().pipe(takeUntil(this.unsubscribe)).subscribe(resp => {
        this.parentForm.get('country').setValue(resp.fullInfo.country);
      })
      const usedAccount = this.parentForm.get("used_account");
      if (usedAccount) {
        usedAccount.setValidators([]);
        usedAccount.setValue('');
      }
    }
    else {
      this.parentForm.addControl("used_account", new UntypedFormControl('', [Validators.required]));
      this.parentForm.get("used_account").setValue(!!this.savedAccounts[0] ? this.savedAccounts[0].value : "");
    }
  }

  ngOnInit(): void {
    this.methodInfo.fields.find(item => item.name === "country").choices.forEach(elem => this.countries.push({ display: elem.display_name, value: elem.value }));
    this.savedAccounts = this.methodInfo.fields.find(item => item.name === "used_account")?.choices
    if (this.savedAccounts && this.savedAccounts.length > 0) {
      this.isAddNewAccount = false;
    }
    else {
      this.isAddNewAccount = true;
    }
    this.createForm(this.isAddNewAccount);
  }


}
